import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { usePriceOverrides } from '../../context/PriceOverridesContext';
import { activePromotions, detroitDate, FEATURED_KEY, formatAdminPrice, PROMOTION_LINKS } from '../../utils/menuContent';
import { featureChoices } from '../../utils/adminCatalog';
import SandwichFallbackArt from './SandwichFallbackArt';
import './MenuHighlights.css';

export const PromotionAnnouncements = () => {
  const { overrides, loading } = usePriceOverrides();
  const { pathname } = useLocation();
  const [today, setToday] = useState(detroitDate);
  useEffect(() => {
    const update = () => setToday(detroitDate());
    const timer = window.setInterval(update, 30000);
    document.addEventListener('visibilitychange', update);
    return () => { window.clearInterval(timer); document.removeEventListener('visibilitychange', update); };
  }, []);
  const promotions = activePromotions(overrides, pathname, today);
  if (loading || pathname === '/admin' || !promotions.length) return null;
  return <aside className="menu-announcements" aria-label="Star Deli announcements and specials">{promotions.map(promotion => <article key={promotion.contentKey} className="menu-announcement">
    <div><h2>{promotion.title}</h2><p>{promotion.message}</p></div>
    {PROMOTION_LINKS[promotion.link] && (promotion.link.startsWith('tel:') ? <a href={promotion.link}>{PROMOTION_LINKS[promotion.link]} ↗</a> : <Link to={promotion.link}>{PROMOTION_LINKS[promotion.link]} →</Link>)}
  </article>)}</aside>;
};

const PinnedItem = ({ item }) => {
  const [failed, setFailed] = useState(false);
  const sandwich = item.moduleKey === 'specialtySandwiches';
  const slug = item.name.toLowerCase().replace(/^the\s+/g, '').trim().replace(/[^a-z0-9]+/g, '-');
  const image = item.image || item.logo || (sandwich && !item.adminAdded ? `/images/sandwiches/${slug}.jpg` : '');
  return <article className="menu-pinned-item">
    {image && !failed ? <img src={image} alt={item.name} loading="lazy" width="320" height="200" onError={() => setFailed(true)} /> : sandwich ? <SandwichFallbackArt sandwich={item} /> : <span className="menu-pin-category">{item.category}</span>}
    <div><h3>{item.name}</h3>{item.price !== undefined && item.price !== '' && <strong>{formatAdminPrice(item.price)}{item.unit ? ` ${item.unit}` : ''}</strong>}{item.description && <p>{item.description}</p>}<Link to={item.href}>View menu →</Link></div>
  </article>;
};

export const PinnedMenuItems = () => {
  const { overrides, loading } = usePriceOverrides();
  if (loading || !Array.isArray(overrides[FEATURED_KEY])) return null;
  const choices = featureChoices(overrides);
  const pinned = [...new Set(overrides[FEATURED_KEY])].map(id => choices.find(item => item.featureId === id && item.available)).filter(Boolean);
  if (!pinned.length) return null;
  return <section className="menu-pinned-section" aria-labelledby="pinned-menu-heading"><h2 id="pinned-menu-heading">In the spotlight</h2><div className="menu-pinned-grid">{pinned.map(item => <PinnedItem key={item.featureId} item={item} />)}</div></section>;
};
